import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm shadow-catering-xs" }
const _hoisted_2 = { class: "text-xs font-medium text-catering-ink-800" }
const _hoisted_3 = { class: "space-y-1" }
const _hoisted_4 = { class: "flex items-baseline justify-between gap-2" }
const _hoisted_5 = { class: "min-w-0 truncate font-medium" }
const _hoisted_6 = { class: "shrink-0 tabular-nums" }
const _hoisted_7 = {
  key: 0,
  class: "text-xs text-catering-ink-500"
}
const _hoisted_8 = {
  key: 1,
  class: "text-xs text-catering-ink-500"
}
const _hoisted_9 = {
  key: 0,
  class: "py-1 text-catering-ink-400"
}
const _hoisted_10 = {
  key: 0,
  class: "mt-1 text-xs text-catering-ink-500"
}


export default {
  __name: 'BotPricingTierList',
  props: { block: { type: Object, required: true } },
  setup(__props) {


function tierThreshold(t) {
  if (t.minimum_item_count) return `${t.minimum_item_count}+ items`
  if (t.minimum_price) return `${t.minimum_price}+`
  return ''
}
function tierReward(t) {
  const parts = []
  if (t.has_discount) parts.push(`${t.discount_label} off`)
  if (t.free_shipping) parts.push('free shipping')
  return parts.join(' + ') || '—'
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("p", { class: "mb-1 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }, "Pricing tiers", -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.stores || [], (s, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: "mb-2 last:mb-0"
      }, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(s.store_name), 1),
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.tiers || [], (t, j) => {
            return (_openBlock(), _createElementBlock("li", {
              key: j,
              class: "py-1 text-catering-ink-900"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(t.title || tierThreshold(t)), 1),
                _createElementVNode("span", _hoisted_6, _toDisplayString(tierReward(t)), 1)
              ]),
              (tierThreshold(t))
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, "when cart reaches " + _toDisplayString(tierThreshold(t)), 1))
                : (t.subtitle)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(t.subtitle), 1))
                  : _createCommentVNode("", true)
            ]))
          }), 128)),
          (!(s.tiers || []).length)
            ? (_openBlock(), _createElementBlock("li", _hoisted_9, "No pricing tiers"))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128)),
    (__props.block.note)
      ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(__props.block.note), 1))
      : _createCommentVNode("", true)
  ]))
}
}

}